import { z } from "zod";
import { searchParam } from "@amber/ui";
import { profileHistoryCategorySchema } from "@amber/profiles/contracts";

const list = (value: string) => z.string().regex(new RegExp(`^(${value})(,(${value}))*$`));

export const profilesSearchSchema = z.object({
  q: searchParam(z.string()),
  status: searchParam(z.string()),
  stale: searchParam(list("stale|never")),
  person: searchParam(z.string()),
  language: searchParam(z.string()),
  platform: searchParam(z.string()),
  problems: searchParam(list("sources|gaps|downloads")),
  owner: searchParam(z.string()),
  tab: searchParam(z.enum(["overview", "sources", "items", "identity", "history"])),
  new: searchParam(z.coerce.string().pipe(z.literal("1"))),
  history: searchParam(profileHistoryCategorySchema),
  window: searchParam(z.coerce.number().pipe(z.union([z.literal(30), z.literal(90), z.literal(180)]))),
});
export type ProfilesSearch = z.infer<typeof profilesSearchSchema>;
